import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const FAQ_KEYS = [
    'based',
    'countries',
    'inquire',
    'fee',
    'complex',
    'corporate',
    'events',
    'private',
    'changes',
] as const

const ChevronIcon = ({ isOpen }: { isOpen: boolean }) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0 transition-transform duration-300 ease-in-out"
        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
    >
        <path
            d="M6.01325 9C5.72684 8.99994 5.45218 8.89476 5.24969 8.7076L0.929687 4.71577C0.826536 4.62372 0.744259 4.5136 0.687657 4.39184C0.631056 4.27009 0.601262 4.13914 0.600016 4.00663C0.59877 3.87412 0.626096 3.74271 0.680399 3.62006C0.734703 3.49742 0.814896 3.386 0.9163 3.2923C1.0177 3.19859 1.13829 3.12449 1.27102 3.07432C1.40374 3.02414 1.54596 2.99889 1.68936 3.00004C1.83276 3.00119 1.97448 3.02872 2.10624 3.08102C2.23801 3.13332 2.35718 3.20935 2.45681 3.30466L6.01325 6.59093L9.56969 3.30466C9.77338 3.12288 10.0462 3.02229 10.3294 3.02456C10.6125 3.02684 10.8834 3.13179 11.0836 3.31682C11.2839 3.50185 11.3975 3.75215 11.3999 4.01381C11.4024 4.27547 11.2935 4.52756 11.0968 4.71577L6.77681 8.7076C6.57431 8.89476 6.29966 8.99994 6.01325 9Z"
            fill="#6B7280"
        />
    </svg>
)

const FaqAccordionItem = ({ question, answer, isOpen, onToggle }: { question: string; answer: string; isOpen: boolean; onToggle: () => void }) => {
    return (
        <div className="border-b border-solid border-[#E5E7EB]">
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between py-[18px] md:py-6 text-left group gap-1"
                aria-expanded={isOpen}
            >
                <span
                    className="md:text-lg sm:text-base text-sm font-medium text-[#6B7280] leading-snug transition-colors duration-200 group-hover:text-[#4B5563]"
                >
                    {question}
                </span>

                <ChevronIcon isOpen={isOpen} />
            </button>

            <div
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{
                    maxHeight: isOpen ? '500px' : '0px',
                    opacity: isOpen ? 1 : 0,
                }}
            >
                <p className="text-xs sm:text-[15px] lg:text-base text-[#4A4A4A] leading-relaxed pb-6">
                    {answer}
                </p>
            </div>
        </div>
    )
}

export const FaqAccordion = () => {
    const { t } = useTranslation('home')
    const [openIndex, setOpenIndex] = useState<number | null>(null)

    const handleToggle = (index: number) => {
        setOpenIndex(prev => (prev === index ? null : index))
    }

    return (
        <div>
            {FAQ_KEYS.map((key, index) => (
                <FaqAccordionItem
                    key={key}
                    question={t(`faq.items.${key}.q`)}
                    answer={t(`faq.items.${key}.a`)}
                    isOpen={openIndex === index}
                    onToggle={() => handleToggle(index)}
                />
            ))}
        </div>
    )
}
